import { useSmartProp } from "@smartfire/js-block-engine";
import {
  PanelBody,
  PanelRow,
  TextControl,
  ToggleControl,
} from "@wordpress/components";
import React from "react";
import { SmartFormField } from "../SmartFormField";

export function SmartFieldInspector({
  editor
}: {
  editor: {
    inspectorTitle?: string;
    smartProp: string;
  };
}) {
  const [fieldSetup, updateFieldSetup] = useSmartProp<SmartFormField>(editor.smartProp);
  return (
    <>
      <PanelBody title={editor?.inspectorTitle ?? `Champ ${fieldSetup.smartProp}`} initialOpen={true}>
        <PanelRow>
          <TextControl
            value={fieldSetup.name}
            label={"Nom"}
            onChange={(value: string) =>
              updateFieldSetup({ ...fieldSetup, name: value })
            }
          />
        </PanelRow>
        <PanelRow>
          <ToggleControl
            label={
              "Champ " + fieldSetup.required ? "Obligatoire" : "Facultatif"
            }
            checked={fieldSetup.required}
            onChange={() =>
              updateFieldSetup({
                ...fieldSetup,
                required: !fieldSetup.required,
              })
            }
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}
